<div class="generate-with-ai-loder p-0 text-center p-0">
  <div class="mwc-text-xl-regular mwc-color-gray-900">{{textTitle}}</div>
  <div class="py-0 loader-img"><img src="assets/images/stars-gif.gif" alt=""/></div>
  <div class="mwc-text-sm-regular mwc-color-gray-600" *ngIf="isForCampaignGenerationIdeas">Project ideas generation may take sometime, please check back again shortly.</div>
  <div class="analysis-in-progress-carousel carousel-control-hide" *ngIf="selectedObjects != null && !isForCampaignGenerationIdeas" style="padding-bottom: 40px;position: relative;">
    <div class="mwc-text-xs-medium mwc-color-gray-500 mb-1" style="font-size: 10px;" *ngIf ="!isForBulkMeta">SEO Tips</div>
    <carousel [isAnimated]="true" [interval]="4000" [(activeSlide)]="activeSlideIndex" [noPause]="false">
      <slide *ngFor="let data of sliderData">
        <div class="slide-item">
          <div class="mwc-text-sm-medium mwc-color-gray-900">{{data.title}}</div>
          <div class="mwc-text-sm-regular mwc-color-gray-600">{{data.desc}}</div>
        </div>
      </slide>
    </carousel>
  </div>
  <button *ngIf="isForCampaignGenerationIdeas" mwc-button mwcType="primary" mwcSize="small" (click)="goToDashboard()" style="width:100%">
    Close
  </button>
</div>
